import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Select } from '../../fields'
import { get } from 'lodash'
import { mapActivitiesCategories, mapActivitiesParents } from '../../../redux/selectors/activities'
import { apiActivities, apiCodeLists } from '../../../helpers/decorators/api'
import { connect } from 'react-redux'
import activitySectionDropdownSelector from '../../../redux/selectors/activities/activitySectionDropdownSelector'


@form({
    form: 'invite-assessor-activity-category-modal',
    disableHook: true
})
@apiActivities({
    activityCategories: true
})
@apiCodeLists(['activitySections'])
@injectIntl
@connect(({ api }) => ({
    dropdownSections: activitySectionDropdownSelector(api),
}))
class InviteAssessorActivityCategoryModal extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func,
        modalId: PropTypes.string,
        modal: PropTypes.func,
        isLoading: PropTypes.bool,
        onApprove: PropTypes.func.isRequired,
        personId: PropTypes.number.isRequired,
        orgId: PropTypes.number.isRequired,
        activities: PropTypes.object.isRequired,
        codeLists: PropTypes.object.isRequired,
        dropdownSections: PropTypes.list
    }

    handleSubmit = (fields, assessorId, orgId) => {
        return this.props.onApprove(fields, assessorId, orgId)
            .then(() => {
                this.props.onSubmit()
                this.props.reset()
            })
    }

    render() {
        const {
            modalId,
            modal,
            handleSubmit,
            isLoading,
            personId,
            orgId,
            activities,
            values,
            dropdownSections
        } = this.props

        const parentId = get(values, 'activityCategory.parent.id')

        const section = get(values, 'activitySection')

        const disabledActivityType = !section

        const disabledActivity = !section && !get (values, 'activityCategory.parent.id')

         const mappedParents = mapActivitiesParents(activities.parents, section)

        const mappedCategories = mapActivitiesCategories(
            activities.list,
            parentId,
            null
        )

        return (
            <Modal id={modalId} modal={modal} customActions>
                <div>
                    <form onSubmit={handleSubmit((fields) => this.handleSubmit(fields, personId, orgId))}>
                        <div>
                        <Select
                            label="Activity Section"
                            intlKey="label.section"
                            name="activitySection"
                            options={dropdownSections}
                        />
                        <Select
                            label="Activity Type"
                            intlKey="label.activity_type"
                            name="activityCategory.parent.id"
                            options={mappedParents}
                            disabled={disabledActivityType}
                            searchable
                            sorted
                        />
                        <Select
                            label="Activity"
                            intlKey="label.activity"
                            name="activityCategory.id"
                            disabled={disabledActivity}
                            options={mappedCategories}
                            sorted
                        />
                        </div>

                        <div style={{ marginBottom: '10px', float: 'right' }}>
                            <Button type="submit" isLoading={isLoading}>
                                <FormattedMessage id="button.add_new_affiliation" defaultMessage="Add new affiliation" />
                            </Button>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }
}

export default InviteAssessorActivityCategoryModal
